import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { ActionTypes, MenuConfigurationLoad, SystemContentLoad } from '@appStore/configuration/actions';
import * as actions from '@appStore/configuration/actions';
import { PermissionsService } from '@appStore/configuration/services/permission.service';
import { ConfigurationService } from '@appStore/configuration/services/configuration.service';

@Injectable()
export class ConfigurationEffects {
  constructor(
    private permissionService: PermissionsService,
    private configurationService: ConfigurationService,
    private actions$: Actions
  ) {}

  loadPermissions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.LoadPermission),
      exhaustMap(action => {
        return this.permissionService.getPermissions().pipe(
          map(messages => new actions.LoadPermissionSuccess(messages)),
          catchError(error => of(new actions.LoadPermissionFail(error)))
        );
      })
    );
  });
 
  loadMenu$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.LoadMenuConfiguration),
      exhaustMap((action: MenuConfigurationLoad) => {
        return this.configurationService.getMenu().pipe(
          map(items => new actions.MenuConfigurationLoadSuccess(items)),
          catchError(error => of(new actions.MenuConfigurationLoadFail(error)))
        );
      })
    );
  });

  loadSystemContent$ = createEffect(()=> {
    return this.actions$.pipe(
      ofType(ActionTypes.LoadSystemContent),
      exhaustMap((action: SystemContentLoad) => {
        return this.configurationService.getSystemContent().pipe(
          map(content => new actions.SystemContentLoadSuccess(content)),
          catchError(error => of(new actions.SystemContentLoadFail(error)))
        );
      })
    );
  });
}
